import React from 'react'
import { SkpLoader } from '@skeepers/skeepers-ui-react'

export const AppLoader = () => (
  <div className="w-fullscreen h-fullscreen flex flex-center">
    <SkpLoader size="large" />
  </div>
)
